import { CoreApp } from '@grafana/data';
import { addEnterpriseProviders } from 'app/AppWrapper';
import { type QueryLibraryDrawerOptions } from 'app/features/explore/QueryLibrary/QueryLibraryContext';

import { QueryLibraryContextProvider } from './QueryLibraryContextProvider';

export function initQueryLibrary() {
  addEnterpriseProviders(QueryLibraryContextProvider);
}

/**
 * This is used to determine the context that the query library is rendered in.
 * The intention was to return a context for tracking event purposes, based on the CoreApp enum.
 * The CoreApp enum is not necessary anymore, as QueryEditor is not rendered in the new modal design.
 * This should be removed in the future.
 */
export function getQueryLibraryRenderContext(app?: string): string {
  switch (app) {
    case CoreApp.Explore:
      return CoreApp.Explore;
    case CoreApp.PanelEditor:
      return CoreApp.PanelEditor;
    case CoreApp.Dashboard:
      return CoreApp.Dashboard;
    case CoreApp.Notebook:
      return CoreApp.Notebook;
    case 'drilldown':
      return 'drilldown';
    case 'command-palette':
      return 'command-palette';
    case 'unconfigured-panel':
      return 'unconfigured-panel';
    case 'dashboard-annotations':
      return 'dashboard-annotations';
    case 'saved-queries-page':
      return 'saved-queries-page';
    case 'saved-queries-detail-page':
      return 'saved-queries-detail-page';
    default:
      return 'unknown';
  }
}

export const getQueryLibraryDrawerAction = ({
  query,
  options,
}: Pick<QueryLibraryDrawerOptions, 'query' | 'options'>) => {
  if (query) {
    return 'save';
  }
  if (options?.isReplacingQuery) {
    return 'replace';
  }
  if (options?.highlightQuery) {
    return 'edit';
  }
  return 'add';
};
